import { useQuery } from 'react-query';
import { FileDescriptorService } from 'services/FileDescriptorService';
import { useAppDispatch } from './useAppDispatch';
import { modalActions } from 'reduxStore/reducers/ModalSlice';
import { FilePreview } from 'ui/redesign/FilePreview';

export const useFetchSingleFile = (readLink: string) => {
  const dispatch = useAppDispatch();

  return useQuery(['fetchSingleFile'], () => FileDescriptorService.downloadSingleFile(readLink), {
    enabled: false,
    onSuccess: (res) => {
      dispatch(
        modalActions.handleOpenModal({
          content: (
            <FilePreview
              file={{
                content: res.data.content ? res.data.content : '',
                type: res.data.contentType ? res.data.contentType : '',
              }}
            />
          ),
          options: {
            title: 'Просмотр',
            contentClassName: 'flex w-screen sm:w-auto items-center justify-center',
          },
        })
      );
    },
  });
};
